<i18n>
en:
  title: "Recipe list"
  name:
    label: "Name"
  slogan:
    label: "Slogan"
  new: "New"
  error:
    load: "load failed."

ja:
  title: "レシピ一覧"
  name:
    label: "料理名"
  slogan:
    label: "キャッチコピー"
  new: "新規登録"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      //- タイトル
      v-row
        v-col(cols="12" align="center")
          h2|{{$t('title')}}
        v-col.pt-0.pb-4(cols="12" align="center")
          v-img(src="@/assets/images/title-underline.png" width="227px" height="24px")

      //- 読込中
      template(v-if="isLoading")
        v-row
          v-col.my-12.pa-12(cols="12")
            v-progress-linear(indeterminate)

      //- 読込失敗
      template(v-else-if="errMsg || !recipes")
        v-row
          v-col.my-12.py-12(cols="12" align="center")
            v-alert.d-inline-block(dense outlined type="error")
              div(v-html="errMsg")

      //- 入力フォーム
      template(v-else)
        v-simple-table.recipes(fixed-header)
          template(v-slot:default)
            thead
              tr
                th.grey.darken-1.white--text.text-left|{{$t('name.label')}}
                th.grey.darken-1.white--text.text-left|{{$t('slogan.label')}}
            tbody
              tr(v-for="(item, index) in recipes" :key="index" @click="$router.push({name: 'ShopRecipe', params: {id: item.recipeId}})")
                td|{{item.name}}
                td|{{item.slogan}}
        br
        div.text-right
          v-btn(x-large color="primary" @click="$router.push({name: 'ShopRecipe', params: {id: 'New'}})")|{{$t('new')}}
</template>

<script>
export default {
  data () {
    return {
      // レシピ
      recipes: null,
      // 読込中
      isLoading: false,
      // エラーメッセージ
      errMsg: null
    }
  },
  created () {
    this.loadHoliday()
  },
  methods: {
    /**
      * レシピを読込
      */
    loadHoliday () {
      this.isLoading = true
      this.errMsg = this.$t('error.load')

      this.api.shopUser({})
        .then(response => {
          return this.api.shopRecipeList({
            shopId: response.data.shopId
          })
            .then(response => {
              this.recipes = response.data

              this.errMsg = null
            })
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.recipes
  tbody
    tr
      cursor: pointer
</style>
